import styles from "./ArticleLeadArt.module.scss";
import { ArticleLayout, ArticleLeadArtSwanFragment } from "types/api";
import ArticleLeadImage from "./ArticleLeadImage";
import ArticleLeadCinemagraph from "./ArticleLeadCinemagraph";
import ArticleLeadEmbed from "./ArticleLeadEmbed";
import { gql } from "utils/urql";
import cx from "classnames";

const ArticleLeadArt = ({
  layout,
  ...props
}: {
  layout: ArticleLayout;
} & ArticleLeadArtSwanFragment) => {
  return (
    <div
      className={cx(
        styles.root,
        layout === ArticleLayout.Feature && styles.feature,
        layout === ArticleLayout.Twocol && styles.twoCol
      )}
    >
      {(props.__typename === "LeadArtImage" ||
        props.__typename === "LeadArtImageLarge" ||
        props.__typename === "LeadArtImageVertical") && (
        <ArticleLeadImage layout={layout} {...props} />
      )}
      {props.__typename === "Cinemagraph" && (
        <ArticleLeadCinemagraph layout={layout} {...props} />
      )}
      {props.__typename === "LeadArtEmbed" && (
        <ArticleLeadEmbed layout={layout} {...props} />
      )}
    </div>
  );
};

ArticleLeadArt.fragment = gql`
  ${ArticleLeadImage.fragment}
  ${ArticleLeadCinemagraph.fragment}
  ${ArticleLeadEmbed.fragment}

  fragment articleLeadArtSwan on LeadArt {
    __typename
    ...articleLeadImage
    ...articleLeadImageLarge
    ...articleLeadImageVertical
    ...articleLeadCinemagraph
    ...articleLeadEmbed
  }
`;

export default ArticleLeadArt;
